// apps/client/src/utils/brokerFilteredAdmin.ts
//
// Shared copy + prop helper for write controls that a broker-restricted
// `office_admin` must not be able to fire.
//
// The server is the access control: `enforceAuthenticated(request)` default-
// denies a filtered admin at the chokepoint unless the callable opts in with
// `allowBrokerFilteredAdmin: true`. This layer exists so such an account is
// never INVITED to press a control that will come back `permission-denied`
// (falsification F6). Controls are DISABLED and labelled, not hidden, so the
// account can see the capability exists and who to ask for it.

/**
 * The one wording for every disabled write control. Kept in a single constant
 * so the six pages that use it cannot drift apart.
 */
export const BROKER_FILTERED_ADMIN_COPY = 'Not available for a broker-restricted account';

/**
 * Spreads onto a control to disable and explain it when `filtered` is true, and
 * to leave it completely untouched when it is false. Callers that already have
 * their own disabled condition should OR it in:
 *
 *   <button {...brokerFilteredAdminProps(isBrokerFilteredAdmin)} disabled={busy || isBrokerFilteredAdmin}>
 */
export function brokerFilteredAdminProps(filtered: boolean): {
  disabled?: true;
  title?: string;
  'aria-disabled'?: true;
} {
  if (!filtered) return {};
  return { disabled: true, title: BROKER_FILTERED_ADMIN_COPY, 'aria-disabled': true };
}
